export default {
    lang: {
        chinese: '简体中文',
        english: 'English',
        tibet: '藏文',
    },
    menu: {
        dashboard: 'མདུན་ངོས།',
        abstract: 'རྟེན་རྫས་བཤམས་མཛོད་ཁང་གི་གནས་ཚུལ་མདོར་བསྡུས།',
        'ab_history': 'ལོ་རྒྱུས་འཕེལ་རིམ།',
        'ab_structuring': 'ལས་ཁུངས་བཀོད་སྒྲིག',
        'ab_words': 'མཛོད་ཁང་གི་འགོ་གཙོའི་ཞུ་ཚིག',
        'ab_events': 'དོན་ཆེན་ཟིན་བཀོད།',
        'ab_expansion_project': 'བསྐྱར་སྐྲུན་རྒྱས་སྐྲུན་གྱི་ལས་གཞི།',
        exhibition: 'བཤམས་སྟོན་གྱི་བརྡ་འཕྲིན།',
        'ex_zhaunti': 'ཆེད་སྒྲིག་བཤམས་སྟོན།',
        'ex_huimou': 'ཆེད་འགྲེམས་ཕྱིར་གཟིགས།',
        'ex_allsence': 'ལྗོངས་ཡོངས་འགྲུལ་བཞུད།',
        zangpinDisplay: 'རྟེན་རྫས་མྱོང་རོལ།',
        'zp_treasures': 'རྟེན་རྫས་རྩ་ཆེན་ཉམས་ཞིབ།',
        'zp_fast_look': 'རིག་དངོས་མྱུར་གཟིགས།',
        'zp_collection_donation': 'རིག་དངོས་བསྡུ་རུབ་དང་སྐྱེས་འབུལ།',
        cultural: 'རིག་གཏོད་ཐོན་རྫས།', //文创产品
        'cul_beautity': 'རིག་གཏོད་སྤུས་ལེགས་ཐོན་རྫས།',
        'cul_news': 'རིག་གཏོད་གནས་སྟངས།',
        educationActivity: 'སློབ་གསོའི་བྱེད་སྒོ།',
        'edu_latest_activities': 'བྱེད་སྒོ་གསར་ཤོས།',
        'edu_special_activities': ' ཆེད་སྒྲིག་བྱེད་སྒོ།',
        'edu_review_activities': 'བྱེད་སྒོར་ཕྱིར་རྟོག',
        'edu_children': 'ལོ་ཆུང་བྱིས་པའི་ཆེད་ཁུལ།',
        'edu_Volunteers': 'དང་བླངས་པའི་ཁྱིམ་གཞི།',
        academic: 'རིག་གཞུང་ཞིབ་འཇུག',
        'academic_institutions': 'རིག་གཞུང་སྡེ་ཁག',
        'academic_book': 'རིག་གཞུང་དུས་དེབ།',
        'academic_classroom': 'རིག་གཞུང་ཁྲིད་སྟེགས།',
        science_technology: 'རྟེན་རྫས་སྲུང་སྐྱོབ་དང་ཞིག་གསོ།',
        'sci_workstation': 'མཉམ་འབྲེལ་ལས་དོན་ས་ཚིགས་ཀྱི་ངོ་སྤྲོད་མདོར་བསྡུས།',
        'sci_achievements': 'སྲུང་སྐྱོབ་ཞིག་གསོའི་འབྲས་བུ།',
        'sci_knowledge': 'ཚན་རིག་ཁྱབ་གདལ་ཤེས་བྱ།',
    },
    search: {
        search_btn: 'འཚོལ་བཤེར།', //搜索
        search_text: 'འདིར་གནད་ཚིག་འཇུག་རོགས་གནང་།' //在此输入关键词语
    },
    common: {
        findMore: 'དེ་བས་མང་པོར་བལྟ།', //查看更多
        findDetails: 'གནས་ཚུལ་ཞིབ་ཕྲར་བལྟ།', //查看详情
        detailTitle: 'གནས་ཚུལ་ཞིབ་ཕྲར་བལྟ།',
        last: 'རིམ་པ་སྔ་མ།', //上一步
        telPhone: 'ལག་ཁྱེར་ཁ་པར་ཨང་གྲངས།', //手机号码
        telPhoneTips: 'ཁྱེད་ཀྱིས་ཡང་དག་པའི་ལག་ཁྱེར་ཁ་པར་ཨང་གྲངས་འབྲི་རོགས།', //请您填写正确手机号码
        formatError: 'རྣམ་པ་ནོར་བ།', //格式错误
        phoneError: 'ལག་ཁྱེར་ཁ་པར་ཨང་གྲངས་འབྲི་སྟངས་ནོར་བ།', //手机号码格式错误
        idCardError: 'ཐོབ་ཐང་དཔང་ཡིག་གི་ཨང་རྟགས་འབྲི་སྟངས་ནོར་བ།', //身份证号码格式错误
        others: 'གཞན་དག', //其他
        time: 'དུས་ཚོད།', //时间
        close: 'སྒོ་གཏན།', //关闭
        refreshed: 'གསར་སྒྱུར་ལེགས་འགྲུབ་བྱུང་།', //刷新成功
        LoadMore: 'སྔར་ལས་མང་པོ་ཁུར་སྣོན།', //加载更多
        noMore: 'གནས་སྐབས་དེ་ལས་མེད།', //暂无更多
        return: 'མདུན་ངོས་སུ་ལོག', //返回首页
        prevPage: 'སྔོན་མ།', //上一篇
        nextPage: 'རྗེས་མ།', //下一篇
        NoPicture: 'གནས་སྐབས་པར་རིས་མེད།', //暂无图片
    },
    home: {
        MuseumNews: 'རྟེན་རྫས་བཤམས་མཛོད་མྱུར་འཕྲིན།', //文博快讯
        Notice: 'འབྲེལ་ཡོད་གསལ་བརྡ།', //相关公告
        OpeningClosingTime: 'སྒོ་ཕྱེ་བ་དང་རྒྱག་པའི་དུས་ཚོད།', //开闭馆时间
        TrafficRoutes: 'འགྲིམ་འགྲུལ་ལམ་ཐིག', //交通路线
        expansionProject: 'བསྐྱར་སྐྲུན་རྒྱས་སྐྲུན་གྱི་ལས་གཞི།', //改扩建工程
        goverPublic: 'ཏང་དོན་དང་སྲིད་དོན་ཡོངས་བསྒྲགས་བྱེད་པ།', //党政务公开
        questionnaire: 'བརྟག་དཔྱད་འདྲི་གཞི།', //问卷调查
        messageBoard: 'སྐད་འཇོག་ས།', //留言板
        policies: 'སྲིད་ཇུས་ཁྲིམས་སྲོལ།', //政策法规
        mailBox: 'མཛོད་ཁང་གི་འགོ་གཙོའི་ཡིག་སྒམ།', //馆长信箱
        beautity: 'རིག་གཏོད་སྤུས་ལེགས་ཐོན་རྫས།', //文创精品
        friendLink: 'ཕུན་ཚོགས་མཛའ་འབྲེལ།', //友情链接
        addressTitle: 'རྟེན་རྫས་བཤམས་མཛོད་ཁང་གི་ས་གནས།', //博物馆地址
        addressContent: 'བོད་རང་སྐྱོང་ལྗོངས་ལྷ་ས་གྲོང་ཁྱེར་ཁྲིང་ཀོན་ཆུས་ནོར་བུ་གླིང་ག་ལམ་ཨང་རྟགས་19པ།', //西藏自治区拉萨市城关区罗布林卡路19号
        contactNumber: 'འབྲེལ་གཏུག་ཁ་པར།', //联系电话
    },
    news: {
        museumNews: 'རྟེན་རྫས་བཤམས་མཛོད་མྱུར་འཕྲིན།', //文博快讯
        notice: 'འབྲེལ་ཡོད་གསལ་བརྡ།', //相关公告
    },
    //留言板
    msgBoard: {
        title: 'སྐད་འཇོག་ས།', //留言板
        textTitle: 'བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་གི་སྤྱི་དམངས་ཀྱིས་སྐད་འཇོག་སའི་བྱང་བུ།', //西藏博物馆公众留言板
        tips: 'གཤམ་གསལ་ཡིག་ཆ་ཞིབ་ཏུ་ཁ་སྐོང་རོགས་གནང་། ང་ཚོས་མྱུར་དུ་ལན་བསློག་ངེས་ཡིན། ཐུགས་རྗེ་ཆེ། བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་གིས་ཁྱེད་ཀྱི་རེ་བ་དང་དགོངས་འཆར་ལ་རེ་སྒུག་བྱེད་བཞིན་ཡོད།', //请准确填写以下资料，我们将尽快作出回复，谢谢！西藏博物馆期待您的咨询和宝贵建议！
        name: 'རུས་མིང་།', //姓名
        phoneNumber: 'ལག་ཁྱེར་ཁ་པར་ཨང་གྲངས།', //手机号码
        suggestion: 'བསམ་འཆར་དང་གྲོས་གཞི།', //意见建议
        vertifyCode: 'ར་སྤྲོད་ཨང་རྟགས་འཇུག་རོགས།', //请输入验证码
        realNamePlaceholder: 'འདིར་མིང་ངོ་མ་འབྲི་རོགས།', //此处填写真实姓名
        realphoneNumberPlaceholder: 'འདིར་ལག་ཁྱེར་ཁ་པར་ཨང་གྲངས་ངོ་མ་འབྲི་རོགས།', //此处填写真实手机号码
        textarea: 'འདིར་ཁྱེད་ཀྱི་འདྲི་བྱའི་གནད་དོན་ནམ་རིན་ཐང་ཅན་གྱི་དགོངས་འཆར་འགོད་རོགས་གནང་།', //在此处填写您的咨询问题或宝贵建议
        namePlease: 'མིང་འབྲི་རོགས།', //请输入姓名
        phoneNumberPlease: 'ལག་ཁྱེར་ཁ་པར་ཨང་གྲངས་འབྲི་རོགས།', //请输入手机号
        suggestionPlease: 'ཁྱེད་ཀྱི་རིན་ཐང་བྲལ་བའི་བསམ་འཆར་འབྲི་རོགས།', //请填写您的宝贵意见
        vertifyCodePlease: 'ར་སྤྲོད་ཨང་རྟགས་འབྲི་རོགས།', //请输入验证码
        vertifyCodeError: 'ར་སྤྲོད་ཨང་རྟགས་ནོར་བ།', //验证码错误
        submit: 'ཡར་སྤྲོད།', //提交留言
        submitSuccess: 'སྐད་འཇོག་ཐུབ་སོང་།', //留言成功
        submitFail: 'སྐད་འཇོག་ཐུབ་མ་སོང་།', //留言失败
        FillInAgain: 'ཡང་བསྐྱར་འབྲི་རོགས།', //重新填写
    },
    //问卷调查
    questionnaire: {
        title: 'བརྟག་དཔྱད་འདྲི་གཞི།', //问卷调查
        finishPlease: 'འདྲི་ཤོག་འགྲུབ་པར་བྱོས།', //请完成答卷
        noFrequentlyPlease: 'ཡང་ཡང་མ་སྤྲོད་རོགས།', //请不要频繁提交
        submit: 'ཡར་སྤྲོད།', //提交答案
        submitSuccess: 'ཡར་སྤྲོད་ཐུབ་སོང་།', //提交成功
        submitFail: 'ལག་ལེན་མ་འགྲུབ་པ།', //操作失败
        Resubmit: 'ཡང་བསྐྱར་ཡར་སྤྲོད།', //重新提交
    },
    //馆长信箱
    mailBox: {
        title: 'བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་གི་འགོ་གཙོའི་ཡིག་སྒམ།', //西藏博物馆馆长信箱
        text: 'དམངས་ཀྱི་སེམས་འདུན་སྔར་བས་ལེགས་པར་མཚོན་ཐུབ་ཆེད། བཤམས་མཛོད་ཁང་གི་འགོ་གཙོའི་ཡིག་སྒམ་རྒྱ་ཆེའི་མང་ཚོགས་རྣམས་ལ་སྒོ་འབྱེད་རྒྱུ་ཡིན་ལ། སྐུ་ཉིད་ཀྱིས་བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་གི་ལས་ཀར་རིན་ཐང་བྲལ་བའི་དགོངས་འཆར་འདོན་པར་དགའ་བསུ་ཞུ།', //为了更好的反映民声，现将馆长信箱对广大用户开放，欢迎您对西藏博物馆的工作提出宝贵的建议意见。
        box: 'ཡིག་སྒམ།' //馆长信箱
    },
    //票务预约
    appointment: {
        title: 'སྤ་སེ་སྔོན་མངགས།', //票务预约
        notice: 'སྤ་སེ་སྔོན་མངགས་ཀྱི་ངེས་དགོས་པ།', //预约须知
        networkApply: 'ད་ལྟ་སྔོན་མངགས་བྱ།', //网上预约
        nowApply: 'ད་ལྟ་སྔོན་མངགས་བྱ།', //立即预约
        today: 'དེ་རིང་།', //今天
        closed: 'སྒོ་རྒྱག', //闭馆
        chooseDatePlease: 'སྔོན་ལ་དུས་ཆད་འཇོག་པའི་ཚེས་གྲངས་གདམ་རོགས།', //请您先选择预约日期
        chooseDate: 'སྔོན་མངགས་དུས་ཚོད་གདམ་པ།', //选择预约日期
        infoTitle: 'སྒེར་གྱི་ཆ་འཕྲིན་སྐོང་བ།', //参观者信息
        fillInfo: 'སྒེར་གྱི་ཆ་འཕྲིན་སྐོང་བ།', //填写个人信息
        visitDate: 'ལྟ་སྐོར་དུས་ཚོད།', //参观时间
        tips1: 'མི་དར་མ་རེ་རེས་ཆེས་མང་ན་1.3mམན་གྱི་བྱིས་པ་གཉིས་ལས་འཁྲིད་མི་ཆོག', //每名成人最多可携带两名1.3m以下的儿童。
        tips2: 'དྲ་ཐོག་ནས་སྔོན་མངག་གམ་སྤྱོད་མཁན་ཐོ་འགོད་བྱེད་སྐབས། ཁྱེད་ཀྱིས་ངེས་པར་དུ་ནུས་པ་ལྡན་པའི་ཐོབ་ཐང་ཆ་འཕྲིན་ཡང་དག་མཁོ་འདོན་བྱ་དགོས་པ་མ་ཟད། ཡང་དག་པར་འབྲི་དགོས། གལ་ཏེ་འབྲི་ནོར་ཤོར་ཚེ་ལྟད་མོའི་འཛིན་བྱང་ལེན་མི་ཐུབ་པར་འགྱུར་ཡང་སྲིད།', //网上预约或注册用户时，请务必提供真实有效身份信息， 并正确填写， 如填写错误， 将有可能无法领取参观票。
        addPerson: 'ཚོགས་མི་སྣོན་པ།', //添加参观者
        addPersonPlease: 'ཚོགས་མི་སྣོན་པ།', //请先添加参观者
        name: 'རུས་མིང་།', //姓名
        idType: 'དཔང་ཡིག་གི་རིགས།', //证件类型
        idNumber: 'དཔང་ཡིག་ཨང་གྲངས།', //证件号码
        namePlease: 'མིང་འབྲི་རོགས།', //请输入姓名
        idTypePlease: 'དཔང་ཡིག་གི་རིགས་འདེམ་རོགས།', //请选择证件类型
        idNumberPlease: 'དཔང་ཡིག་ཨང་གྲངས་འབྲི་རོགས།', //请输入证件号码
        delete: 'གསུབ་པ།', //删除
        idCard: 'ཐོབ་ཐང་དཔང་ཡིག', //身份证
        passport: '护照', //护照
        reset: 'བསྐྱར་སྒྲིག', //重置
        confirmAdd: 'གཏན་འཁེལ།', //确定添加
        confirmOrder: 'ཉོ་ཐོའི་ཆ་འཕྲིན་གཏན་འཁེལ།',
        finishApply: 'སྤ་སེ་སྔོན་མངགས་འགྲུབ་པ།', //完成票务预约
        success: 'སྔོན་མངགས་ལེགས་འགྲུབ་བྱུང་བར་རྟེན་འབྲེལ་ཞུ།', //恭喜，预约成功
        successNotice: 'སྐུ་ཉིད་ཀྱིས་ལྟ་སྐོར་གྱི་ཉིན་དེར་ནུས་ལྡན་དཔང་ཡིག་བཟུང་ནས་བཤམས་མཛོད་ཁང་དུ་ཕེབས་རོགས།', //请于参观当日持有效证件入馆参观
    },
    //展览展讯
    exhibition: {
        special: 'ཆེད་སྒྲིག་བཤམས་སྟོན།', //专题展览
        review: 'ཆེད་འགྲེམས་ཕྱིར་གཟིགས།', //特展回眸
        allsence: 'ལྗོངས་ཡོངས་འགྲུལ་བཞུད།', //全景漫游
        detail: 'བཤམས་སྟོན་གྱི་གནས་ཚུལ་ཞིབ་ཕྲ།',
        openDate: 'འགྲེམ་སྟོན་སྒོ་འབྱེད།', //开展时间
        closeDate: 'འགྲེམ་སྟོན་སྒོ་རྒྱག', //闭展时间
        position: 'གནས་ཡུལ།', //展览位置
        area: 'རྒྱ་ཁྱོན།', //展览面积
        theme: 'བརྗོད་གཞི།', //展览主题
        struct: 'སྒྲིག་གཞི།', //展览结构
        content: 'འགྲེམ་སྟོན་གྱི་ནང་དོན།', //展览内容
        relics: 'འགྲེམ་སྟོན་གྱི་རིག་དངོས།', //展览文物
        fullView: 'འགྲེམ་སྟོན་གྱི་ལྗོངས་རྣམ།', //展览全景
        changSheView: '常设展览',
        linShiView: '临时展览',
        zhuanTiView: '专题展览'
    },
    //展品
    exhibits: {
        treasure: 'རྟེན་རྫས་རྩ་ཆེན་ཉམས་ཞིབ།', //珍品赏析
        fastLook: 'རིག་དངོས་མྱུར་གཟིགས།', //文物快览
        collection: 'རིག་དངོས་བསྡུ་རུབ་དང་སྐྱེས་འབུལ།', //文物征集与捐赠
        collectionRelics: 'རིག་དངོས་བསྡུ་རུབ།', //文物征集
        donationRelics: 'རིག་དངོས་སྐྱེས་འབུལ།', //文物捐赠
        statues: 'འདྲ་བརྙན།', //造像
        thangka: 'ཐང་ཀ', //唐卡
        historicalRelics: 'ལོ་རྒྱུས་རིག་དངོས།', //历史文物
        porcelains: 'རྫ་ཆས།', //瓷器
        jadeArticles: 'གཡང་ཊིའི་ཡོ་ཆས།', //玉器
        religiousImplements: 'མཆོད་ཆས།', //法器
        ancientBooks: 'གནའ་བོའི་དཔེ་རྙིང་།', //古籍文献
        folkCustoms: 'དམངས་སྲོལ།', //民俗
        others: 'གཞན་དག', //其他
    },
    // 文创
    cultural: {
        beautity: 'རིག་གཏོད་སྤུས་ལེགས་ཐོན་རྫས།', //文创精品
        product: 'རིག་གཏོད་ཐོན་རྫས།', //文创产品
        news: 'རིག་གཏོད་གནས་སྟངས།', //文创动态
    },
    //活动
    activity: {
        latest: 'བྱེད་སྒོ་གསར་ཤོས།', //最新活动
        special: 'ཆེད་སྒྲིག་བྱེད་སྒོ།', //专题活动
        review: 'བྱེད་སྒོར་ཕྱིར་རྟོག', //活动回顾
        children: 'ལོ་ཆུང་བྱིས་པའི་ཆེད་ཁུལ།', //少儿专区
        volunteers: 'དང་བླངས་པའི་གཟི་བྱིན།', //志愿者风采
        home: 'དང་བླངས་པའི་ཁྱིམ་གཞི།', //志愿者之家
        volunteersTitle: 'བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་གིས་ལྗོངས་ཡོངས་སུ་ཁ་ཕྱོགས་ཏེ་དང་བླངས་པ་བསྡུ་རྒྱུ་ཡིན།', //西藏博物馆面向全区招募志愿者
        volunteersBrief: 'བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་གིས་ཐེངས་འདིར་དང་བླངས་པ་བསྡུ་པར་ལོ་ཧྲིལ་བོར་མིང་ཐོ་བཀོད་ཆོག་པ་མ་ཟད། དང་བླངས་པའི་ཁ་གྲངས་ལ་ཚད་བཀག་མེད།  དང་བླངས་པར་རེ་ཞུ་གནང་མཁན་གྱིས་ངེས་པར་དུ་རྒྱལ་ཁབ་ཀྱི་བཅའ་ཁྲིམས་དང་ཁྲིམས་སྲོལ་བརྩི་སྲུང་དང་། མེས་རྒྱལ་ལ་དགའ་ཞེན། རྟེན་རྫས་བཤམས་མཛོད་ཁང་གི་སྤྱི་ཕན་བྱ་གཞག་ལ་དགའ་ཞེན་ཡོད་དགོས།', //西藏博物馆此次志愿者招募接受常年报名，而且名额不限。申请人要求必须遵守国家法律法规，热爱祖国、热心博物馆公益事业
        joinUs: 'ང་ཚོའི་གྲས་སུ་ཞུགས་པ།', //加入我们
        time: 'དུས་ཚོད།', //活动时间
        details: 'བྱེད་སྒོའི་གནས་ཚུལ་ཞིབ་ཕྲ།', //活动详情
        download: 'མིང་ཐོ་འགོད་པའི་ཟུར་སྣོན་ཡིག་ཆ་ཕབ་ལེན།', //下载报名附件
    },
    academic: {
        institutions: 'རིག་གཞུང་སྡེ་ཁག', //学术机构
        book: 'རིག་གཞུང་དུས་དེབ།', //学术期刊
        classroom: 'རིག་གཞུང་ཁྲིད་སྟེགས།', //学术讲堂
        downloadNum: 'ཕབ་ལེན་བྱེད་ཚད།', //下载量
        download: 'ཕབ་ལེན།', //点击下载
        noVideo: 'བརྙན་ཟློས་འདི་གཏོང་མི་ཐུབ། ཅུང་འགོར་རྗེས་ཚོད་ལྟ་གནང་རོགས།', //此视频暂无法播放，请稍后再试
    },
    //科技保护
    protection: {
        workstation: 'མཉམ་འབྲེལ་ལས་དོན་ས་ཚིགས།', //联合工作站
        achievements: 'སྲུང་སྐྱོབ་ཞིག་གསོའི་འབྲས་བུ།', //保护修复成果
        knowledge: 'ཚན་རིག་ཁྱབ་གདལ་ཤེས་བྱ།', //科普知识
        knowledgeTitle: 'རིག་དངོས་ཀྱི་ཚན་རིག་ཁྱབ་གདལ་ཤེས་བྱ།', //臧品科普知识
        knowledgeContent: 'རྟེན་རྫས་བཤམས་མཛོད་ཁང་ལ་ལོ་ཆུང་གཞོན་ནུའི་སློབ་གསོའི་ཁྲོད་དུ་ཐུན་མོང་མ་ཡིན་པའི་དགེ་མཚན་ལྡན་ཞིང་། དུས་རབས་མི་འདྲ་བ་དང་ཁྱད་ཆོས་མི་འདྲ་བའི་རྟེན་རྫས་ཚང་མ་སྒྱུ་རྩལ་དང་མཛེས་སྡུག་གི་གཞི་རྟེན་ཡིན་ལ། ལོ་ཆུང་གཞོན་ནུ་རྣམས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་དུ་འགྲོ་རུ་བཅུག་པ་ནི་ཁོ་ཚོ་སྒྱུ་རྩལ་གྱི་ཁང་བཟང་དུ་ཁྲིད་པ་དང་འདྲ། སྲོལ་རྒྱུན་གྱི་སྣེ་ཤན་པའི་འགྲེལ་བརྗོད་ཙམ་ལ་བརྟེན་པའི་གནས་ཚུལ་དང་བསྡུར་ན། ལོ་ཆུང་གཞོན་ནུ་རྣམས་ཀྱིས་རྣམ་པ་ཟོར་ཡང་ཞིང་སྒྱུ་རྩལ་གྱི་རང་བཞིན་ལྡན་ལ། སྤྲོ་སྣང་རང་བཞིན་ལྡན་པའི་སློབ་གསོའི་ནང་དོན་ལ་དེ་བས་རེ་འདོད་ཆེན་པོ་ཡོད།', //
        restorationTitle: 'རྟེན་རྫས་སྲུང་སྐྱོབ་དང་ཞིག་གསོ།', //臧品修复与保护
        restorationContent: 'བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་ནི་ཕྱོགས་བསྡུས་རང་བཞིན་གྱི་མི་རིགས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་ཞིག་ཡིན་པའི་ཆ་ནས། དེར་ཉར་ཚགས་བྱས་པའི་རིག་དངོས་ཀྱི་ཁ་གྲངས་མང་ཞིང་རིགས་སྣ་ཚོགས་ཡོད། དེར་ཚན་རིག་དང་མཐུན་པའི་སྒོ་ནས་རིགས་དགར་བ་ནི་རིག་དངོས་ཀྱི་ཆ་འཕྲིན་ལེགས་པར་བཀོལ་བ་དང་རྟེན་རྫས་ལ་སྲུང་སྐྱོབ་བྱེད་པའི་སྔོན་འགྲོ་ཡིན། བོད་ལྗོངས་རྟེན་རྫས་བཤམས་མཛོད་ཁང་གི་རིག་དངོས་མཛོད་ཁང་དུ་བཞག་རྗེས།  རིག་དངོས་སྲུང་སྐྱོབ་མི་སྣས་དེར་ཚན་རིག་དང་མཐུན་པའི་སྒོ་ནས་རིགས་དབྱེ་བ་དང་ཐོ་འགོད་པ། དཀར་ཆག་སྒྲིག་པ་སྟེ། ཐོག་མར་རིག་དངོས་ཀྱི་བྱེད་ལས་སམ་ནུས་པ། རྒྱུ་ཆ། ཁ་གྲངས་སོགས་ཉར་ཚགས་ཀྱི་ཁྱད་ཆོས་གཞིར་བཟུང་ནས་རྟེན་རྫས་ཡོད་ཚད་སྐུ་འདྲ་དང་ཐང་ག དར་གོས། ཆོས་ལུགས་ཡོ་ཆས། གནའ་དཔེ། རྫ་ཆས། གཡང་ཊིའི་ཡོ་ཆས། གཡུ་རྩིའི་ཡོ་ཆས། དངུལ་ཆས་སོགས་རིགས་བཅུ་དགུ་རུ་དབྱེ་བ་དང་། དེ་ནས་རེ་རེ་བཞིན་ཨང་གྲངས་འགོད་པ་དང་པར་ལེན་པ། རྟེན་རྫས་ཀྱི་སྤྱིའི་ཐོ་ཡིག་བཟོ་དགོས། བོད་ ལྗོངས་ རྟེན་ རྫས་ བཤམས་ མཛོད་ ཁང་ གི་ རྟེན་ རྫས་ ཀྱི་ དགེ་ མཚན་ དང་ ཞིབ་ འཇུག་ གི་ དགེ་ མཚན། འགྲེམ་ སྟོན་ གྱི་ དགེ་ མཚན་ བཅས་ མངོན་ པར་ དོད་ པ་ དང་ མཉམ་ དུ། བཤམས་ མཛོད་ ཁང་ གི་ དབུ་ ཁྲིད་ ཀྱིས་ རིག་ དངོས་ ལ་ ཚན་ རྩལ་ གྱིས་ སྲུང་ སྐྱོབ་ གནང་ པར་ གཙིག་ མཐོང་ ཆེ་ ནས་ ཆེ་ རུ་ བྱེད། སྔ་ རྗེས་ སུ་ འབྲེལ་ ཡོད་ ཆེད་ ལས་ མི་ སྣ་ ནང་ ལོག་ གི་ སྤུན་ ཟླ་ ལྟ་ བུའི་ བཤམས་ མཛོད་ ཁང་ དུ་ སྔོན་ ཐོན་ གྱི་ རིག་ དངོས་ སྲུང་ སྐྱོབ་ དང་ སླར་ གསོའི་ ལག་ རྩལ་ དང་ བསམ་ བློ་ སློབ་ སྦྱོང་ གནང་ པར་ མངགས་ ལ། རྒྱལ་ ཁབ་ རིག་ དངོས་ ཅུས་ ཀྱིས་ གཙོ་ སྒྲུབ་ གནང་ པའི་ འཁེལ་ འཐག་ ཐོན་ རྫས་ ཀྱི་ ཆེད་ དོན་ སྲུང་ སྐྱོབ་ ཞིག་ གསོའི་ གསབ་ སྦྱོང་ འཛིན་ གྲྭར་ ཞུགས་ པ་ མ་ ཟད། 2012 ལོར་ རང་ རེའི་ བཤམས་ མཛོད་ ཁང་ དུ་ ཐང་ ག་ སྲུང་ སྐྱོབ་ ལས་ དོན་ ཁང་ བཙུགས། ',
        compare: 'ཉམས་གསོའི་སྔ་རྗེས་བསྡུར་བ།', //修复前后对比
        before: 'ཞིག་གསོའི་སྔོན།', //修复前
        after: 'ཞིག་གསོའི་རྗེས།', //修复后
    }
} //